export default __webpack_public_path__ + "static/media/bb2.2.368d0b53.png";